import EnvHelper from "../../lib/env-helper";

export default function sendCookieNotification() {
	const cookie = costorage.get('h_cookie-ntf');

	if (!cookie) {
		const $root = document.querySelector('.cookie-ntf');

		if (!$root) {
			return;
		}

		const $agreementBtn = $root.querySelector('.cookie-ntf_agreement');
		const $privacyPageLink = document.getElementById('cookie-ntf-privacy-page-link');
		const cityInfo = EnvHelper.cityInfo;

		if (EnvHelper.siteName !== 'school' && cityInfo && cityInfo.citySwitchUrl) {
			$privacyPageLink.href = cityInfo.citySwitchUrl + 'privacy';
		}

		$agreementBtn.addEventListener('click', () => {
			costorage.set('h_cookie-ntf', '1', { expires: 30 * 24 * 60 * 60, domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
			$root.classList.remove('-visible');
		});

		setTimeout(() => {
			$root.style.display = null;

			setTimeout(() => {
				$root.classList.add('-visible');
			}, 20);
		}, 3000);
	}
}